export default __webpack_public_path__ + "static/media/Animations_Circle9.44e6e47c.svg";